import { render, staticRenderFns } from "./List.vue?vue&type=template&id=8f5b6268&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=8f5b6268&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5b6268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5b6268')) {
      api.createRecord('8f5b6268', component.options)
    } else {
      api.reload('8f5b6268', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=8f5b6268&scoped=true", function () {
      api.rerender('8f5b6268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/List.vue"
export default component.exports